import axios from 'axios';
import contentDisposition from 'content-disposition';


export const getAvailableFilterValues = location => axios.get(location)
    .then(r => r.data.map(i => ({ title: i, value: i })));

export const fetchProductClass = product => axios.get('/SystemInfo/ModelStatic', { params: { product } })
    .then(r => r.data);

export const uploadFile = (data) => axios.post(`CommodityFutureReport/UploadFile?runDate=${data.runDate}`, data.rows)
    .then(res => res );

    export const getFileUploads = (request) => axios.get('CommodityFutureReport/GetUploadedFilesFromServer')
    .then(r => r.data.files.map(({fileId, fileName,createdAt,status, runDate })=>{ 
        return {id: fileId, fileName, fileId, rundate: runDate, status, createdAt};      
      }));

export const getCommodityReportsFromCloud = (request) => axios.get('CommodityFutureReport/GetListOfReportsFromServer')
      .then(r => r.data.map(({reportId, runDate, fileName, createdAt })=>{ 
          return {id: reportId, runDate, fileName, createdAt};      
        }));
export const validateFile = (file) => axios.post('CommodityFutureReport/ValidateUploadFile', file).then(response => response.data);

export const getCommodityReports = (request) => axios.get('CommodityFutureReport/GetUploadedReportsFromServer',)
      .then(r => r.data.map(({requestId, runDate, data, createdAt })=>{ 
          return {id: requestId, runDate, data, createdAt};      
        }));

export const exportCommodityReport = (ids) => {     
    let suffix = 'sZip?ids='
    let obj = ids
    let zip = true
    if (ids.length === 1){
        suffix = '?id='
        obj = ids[0]
        zip = false
    }
    
    return axios.get(`CommodityFutureReport/ExportCommodityReport${suffix}${obj}`,{
        responseType: 'blob',
      }).then((response) => {
        const parsedContentDisposition = response.headers['content-disposition'] && contentDisposition.parse(response.headers['content-disposition']);
        return { data: response.data, filename: parsedContentDisposition.parameters.filename, zip: zip }
    })
    
}   

export const getDailyFiles = () => axios.get('CommodityFutureReport/GetDailyFiles').then(response => response.data);

        